module.exports = __webpack_public_path__ + "img/pt_success.89450c9d.png";